import * as constActions from './scannerPageConstActions';

import initialState from './initialState';

export default function searchPageReducer(state = initialState, action) {
  switch (action.type) {
    case constActions.INIT_SCANNER_DATA: {
      return Object.assign({}, state, {
        results: action.results
      });
    }

    case constActions.GET_SCANNER_COLUMNS: {
      return Object.assign({}, state, {
        allColumns: action.columns
      });
    }

    case constActions.GET_SCANNER_HEADER_COLUMNS: {
      return Object.assign({}, state, {
        headerColumns: action.headers
      });
    }
    case constActions.FETCH_SCANNER_RESULTS: {
      return Object.assign({}, state, {
        results: action.results
      });
    }
    case constActions.FETCH_SCANNER_EXISTING_RESULTS:
      return Object.assign({}, state, {
        results: [...state.results, ...action.results]
      });
    case constActions.SET_NUMBER_OF_SCANNED_RESULTS: {
      return Object.assign({}, state, {
        scannedStatistics: action.results
      });
    }
    case constActions.GET_SCANNER_STATUS: {
      return Object.assign({}, state, {
        scannerStatus: action.result
      });
    }

    case constActions.AUTO_REFERSH_SCANNER:
      return Object.assign({}, state, {
        isAutoRefresh: action.isAutoRefresh
      });

    case constActions.DISPATH_SCANNER_SELECTED_ROWS:
      return Object.assign({}, state, {
        selectedRows: action.selectedRows
      });
    case constActions.DISPATH_SCANNER_ALL_SELECTED_ROWS:
      return Object.assign({}, state, {
        selectedRows: action.selectedRows,
        isSelectAllChecked: action.isSelectAllChecked
      });

    case constActions.DISPATCH_SCANNER_APPROVED_ROWS:
      return Object.assign({}, state, {
        approvedRows: action.approvedRows,
        isAllApproved: action.isAllApproved
      });
    case constActions.DISPATCH_SCANNER_SELECTED_ACTION_ROW:
      return Object.assign({}, state, {
        selectedScannerActionData: action.selectedScannerActionData
      });

    default:
      return state;
  }
}
